import { HEX_COLOR_REGEX } from 'helpers/regex';
import { object, string } from 'yup';

const VARIABLES_DEFAULT = {
  items: {
    color: 'red',
    size: 20,
    showBadges: true,
  },
  showAds: true,
};

const PAYWALL_SCHEMA = object().shape({
  webCopyButton: string().required(),
  webImage: string().required(),
  webImageResp: string().required(),
  webPromoText: string().required(),
  webSku: string().required(),
  webColor: string().matches(HEX_COLOR_REGEX).required(),
});

const PAYWALL_NBY_SCHEMA = object().shape({
  webCopyButton: string().required(),
  webImage: string().required(),
  webImageResp: string().required(),
  webPromoText: string().required(),
  webSku: string().required(),
  webColor: string().matches(HEX_COLOR_REGEX).required(),
});

const PP_SCHEMA = object().shape({
  webDiscountPremiumFirst: string().required(),
  webDiscountPremiumSecond: string().required(),
  webDiscountPremiumThird: string().required(),
  webImagePP: string().required(),
  webImagePPResp: string().required(),
  webMonthlyPricePremiumFirst: string().required(),
  webMonthlyPricePremiumSecond: string().required(),
  webMonthlyPricePremiumThird: string().required(),
  webPPCopyButton: string().required(),
  webSkuPremiumFirst: string().required(),
  webSkuPremiumSecond: string().required(),
  webSkuPremiumThird: string().required(),
  webTitlePremiumFirst: string().required(),
  webTitlePremiumSecond: string().required(),
  webTitlePremiumThird: string().required(),
  webColor: string().required(),
  // webTitlePremiumThird2: string().required(),
});

export { VARIABLES_DEFAULT, PAYWALL_SCHEMA, PAYWALL_NBY_SCHEMA, PP_SCHEMA };
